import { inject } from 'inversify';

import { STATUS } from '@/constants';
import { service } from '@/decorators/service';
import { SignalrListener, SignalrMessage } from '@/decorators/signalr';
import { RequestCancellationReasonsStore } from '@/stores/RequestCancellationReasonsStore';
import { orderByField } from '@/utils/orderBy';
import { RequestCancellationReasonInfo } from '~/api/IRequestCancellationReasonInfo';
import { IDispatchMessage } from '~/api/messages/IDispatchMessage';
import { IRequestCancellationReasonRespMsg } from '~/api/messages/IRequestCancellationReasonRespMsg';
import { IRequestCancellationReasonUpdateRespMsg } from '~/api/messages/IRequestCancellationReasonUpdateRespMsg';

@SignalrListener
@service(RequestCancellationReasonManager)
export class RequestCancellationReasonManager {
  @inject(RequestCancellationReasonsStore) protected requestCancellationReasonsStore: RequestCancellationReasonsStore;

  @SignalrMessage('TransportRequestCancelReasonsRespMsg')
  async onRequestCancellationReasonRespMsg(response: IRequestCancellationReasonRespMsg & IDispatchMessage) {
    this.update(response.cancelReasons);
  }

  @SignalrMessage('TransportRequestCancelReasonUpdateRespMsg')
  async onRequestCancellationReasonUpdateRespMsg(response: IRequestCancellationReasonUpdateRespMsg & IDispatchMessage) {
    this.update([response.cancelReason]);
  }

  update(cancelReasons: RequestCancellationReasonInfo[]) {
    this.requestCancellationReasonsStore.batchUpdate(cancelReasons);
  }

  findRequestCancellationReason(id: number) {
    return this.requestCancellationReasonsStore.find(Number(id));
  }

  get all() {
    const reasons = this.requestCancellationReasonsStore.all()
      .filter((reason) => reason.status !== STATUS.DISABLED);
    return orderByField(reasons, this.requestCancellationReasonsStore.valueKey);
  }
}
